module.exports = __webpack_public_path__ + "assets/img/img-2.645b126f.png";